import React from 'react'

export default function Footer() {
  return (
    <div>

<footer class="footer">
      <div class="top-footer">
        <div class="tf-container">
          <div class="row">
            <div class="col-lg-2 col-md-4">
              <div class="footer-logo">
                <img src="images/logo.png" alt="images" />
                <p className="para1" style={{marginLeft:'80px',marginTop:'-10px'}}>A <a href="https://www.tekworks.in/" target='_blank'><span style={{color:'#808080'}}>TekWorks</span></a> Product</p>
              </div>
            </div>
            <div class="col-lg-10 col-md-8">
              <div class="wd-social d-flex aln-center">
                <span>Follow Us:</span>
                <ul class="list-social d-flex aln-center">
                  <li>
                    <a href="https://www.facebook.com/tekworks.in"><i class="icon-facebook"></i></a>
                  </li>
                  <li>
                    <a href="https://www.linkedin.com/company/tekworks-in"><i class="icon-linkedin2"></i></a>
                  </li>
                  <li>
                    <a href="https://www.instagram.com/tekworks_hiring"><i class="icon-instagram1"></i></a>
                  </li>
                  <li>
                    <a href="https://www.youtube.com/@TekWorks-in"><i class="icon-youtube"></i></a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="inner-footer">
        <div class="tf-container">
          <div class="row">
            <div class="col-lg-4 col-md-6">
              <div class="footer-cl-1">
                <p>
                  Job Searching Just Hot Easy. Use <strong>bitLabs Jobs</strong> To Run A Hiring Site
                  And Earn Money In The Process!
                </p>
                <p>
                We Serve Corporates And Start-Ups, Who Find Themselves Overextended, Trying To Find The Right Leadership 
                Talent To Achieve Their Goals And Milestones.
              
                </p>
                
              </div>
            </div>
            <div class="col-lg-2 col-md-6 col-6">
              <div class="footer-cl-2">
                <h6 class="ft-title">Quick Links</h6>
                <ul class="navigation-menu-footer">
                  <li><a href="/aboutus">About</a></li>
                  <li><a href="/candidate">Find Jobs</a></li>
                  <li><a href="/recruiter">Find Candidates</a></li>
                  <li><a href="/contactus">Contact</a></li>
                </ul>
              </div>
            </div>
            <div class="col-lg-2 col-md-6 col-6">
              <div class="footer-cl-3">
              <h6 class="ft-title">     </h6>
                <ul class="navigation-menu-footer">
                <li><br /></li>
                  <li><a href="/termsofservices">Terms Of Services</a></li>
                  <li><a href="/privacypolicy">Privacy Policy</a></li>
                  <li>
                    <a href="/cookiepolicy">Cookie Policy</a>
                  </li>
                </ul>
              </div>
            </div>
            <div class="col-lg-4 col-md-4 col-6">
            <h6 class="ft-title">Reach us</h6>
              
              <div class="icon-infor d-flex aln-center">
                  <div class="icon">
                    <span class="icon-call-calling"><span class="path1"></span><span class="path2"></span><span
                        class="path3"></span><span class="path4"></span></span>
                  </div>
                  <div class="content">
                    <p>Need help? 24/7</p>
                    <h6><a href="tel:9966662524" style={{ fontFamily: 'inherit' }}>+91-9966662524</a></h6>
                  </div>
                </div>
                <div class="ft-icon">
                  <i class="icon-map-pin"></i> 54-15-18E, Gurunanak Colony Road, 3rd Floor, Sai Odessey Complex, Gurunanak Colony, Vijayawada
                </div>
            </div>
          </div>
          <div class="bottom">
        <div class="tf-container" align="center">
                <div className="copyright" style={{ marginLeft: '-25px',fontFamily:'inherit' }}> 
  <br /><br />
  ©2023 TekWorks. All Rights Reserved.
</div>

        </div>
      </div>
        </div>
      </div>
    </footer>
     </div>
  )
}
